import { useEffect, useState } from 'react';
import { apiClient } from '@/core/api/client';
import { MaintenancePage } from './MaintenancePage';

interface MaintenanceStatus {
  enabled: boolean;
  message: string;
}

export function MaintenanceCheck({ children }: { children: React.ReactNode }) {
  const [maintenance, setMaintenance] = useState<MaintenanceStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const status = await apiClient.fetchUserMaintenance();
        setMaintenance(status);
      } catch {
        // If API fails, assume no maintenance
        setMaintenance({ enabled: false, message: '' });
      } finally {
        setLoading(false);
      }
    };

    checkMaintenance();
  }, []);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: '#070707',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '3px solid rgba(255, 214, 10, 0.2)',
          borderTopColor: '#facc15',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (maintenance?.enabled) {
    return <MaintenancePage message={maintenance.message} />;
  }

  return <>{children}</>;
}
